import { render, staticRenderFns } from "./SupplierRequestDetails.vue?vue&type=template&id=72beb52f&"
import script from "./SupplierRequestDetails.vue?vue&type=script&lang=js&"
export * from "./SupplierRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports